import { AbstractDownloadableService } from "./abstract-downloadable.service";
import { SmsLog } from "../models";

/**
 * @class SmsLogPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<SmsLog>}
 */
export class SmsLogPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/sms-log(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SmsLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SmsLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<SmsLog>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    getGraph(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url + '/graph', {
                headers: this.authHeaders,
                params,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    exportPdf(params = {}, property) {

        const url = this.url({propertyId: property.id}) + '/export-pdf';

        return this.download(url, params, 'Sms Log.pdf');
    }

    exportCsv(params = {}, property) {

        const url = this.url({propertyId: property.id}) + '/export-csv';

        return this.download(url, params, 'Sms Log.csv');
    }

    exportExcel(params = {}, property) {

        const url = this.url({propertyId: property.id}) + '/export-excel';

        return this.download(url, params, 'Sms Log.xls');
    }

    sendEmail(params = {}, property ) {

        const url = this.url({propertyId: property.id}) + '/send-email';

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/sms-log.service.js